import { create } from "zustand";

export const settingsStoreDefaultData: SettingsStore["data"] = {
    animationsEnabled: true,
};

export type SettingsStore = {
    data: {
        animationsEnabled: boolean;
    };
    set: {
        data: (
            fn: (
                data: Partial<SettingsStore["data"]>
            ) => Partial<SettingsStore["data"]>
        ) => void;
    };
};

const useSettingsStore = create<SettingsStore>((set, get) => ({
    data: {
        animationsEnabled: true,
    },
    set: {
        data: (data) => set({ data: { ...get().data, ...data } }),
    },
}));

export default useSettingsStore;
